exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tax-configurations-container{display:flex;flex-wrap:wrap;gap:4%}", ""]);

// exports
